import { render, staticRenderFns } from "./SalesAppraisal.vue?vue&type=template&id=1fc6ab3f&"
import script from "./SalesAppraisal.vue?vue&type=script&lang=ts&"
export * from "./SalesAppraisal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports